import { IDeliveryRoute } from "../../apis/delivery-route"

export type RouteProgress = "WAITING_DRIVER" | "PICKING" | "HANDOVER_READY" | "PRETRIP_PENDING"

const DEAD_DN = new Set(["CANCELLED", "CANCELED", "RETURNED"])
const LOADING_DN = new Set(["", "DRAFT", "ASSIGNED"])

const liveDnStatuses = (route: IDeliveryRoute) =>
  (route.stops ?? [])
    .map((s) => (s.dn?.deliveryNoteStatus ?? "").toUpperCase())
    .filter((s) => !DEAD_DN.has(s))

export function routeProgress(route: IDeliveryRoute): RouteProgress | null {
  if (route.status !== "PLANNED" && route.status !== "LOADING") return null
  const hasDriver = !!route.driverId || !!route.driver
  const hasVehicle = !!route.vehicleId || !!route.vehicle
  if (route.status === "PLANNED" || !hasDriver || !hasVehicle) return "WAITING_DRIVER"
  const live = liveDnStatuses(route)
  if (live.length === 0) return null
  if (live.some((s) => LOADING_DN.has(s))) return "PICKING"
  if (live.includes("PENDING_HANDOVER")) return "HANDOVER_READY"
  return "PRETRIP_PENDING"
}

export function routeLoadedPct(route: IDeliveryRoute): number {
  const live = liveDnStatuses(route)
  if (live.length === 0) return 0
  return Math.round((live.filter((s) => !LOADING_DN.has(s)).length / live.length) * 100)
}
